import { render, staticRenderFns } from "./CTextarea.vue?vue&type=template&id=e3f85304&scoped=true"
import script from "./CTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./CTextarea.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CTextarea.vue?vue&type=style&index=0&id=e3f85304&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3f85304",
  null
  
)

export default component.exports